/**
 * URL do asset dentro da mensagem de falha do Webpack, nos formatos
 * `Loading chunk 1 failed.\n(error: https://...)` e
 * `Loading CSS chunk 1 failed.\n(https://...)`.
 */
export const extractChunkUrlFromMessage = (
	message: string | undefined
): string | undefined => {
	const match = message?.match(
		/\((?:(?:error|missing|timeout):\s*)?(https?:\/\/[^)]+)\)/
	);
	return match?.[1] ?? undefined;
};

/**
 * Restringe a URL extraída aos assets de mesma origem em `/static/js/` e
 * `/static/css/`. Nada fora disso é consultado na rede.
 */
export const getStaticAssetUrl = (chunkUrl: string): URL | null => {
	try {
		const url = new URL(chunkUrl);
		if (
			url.origin !== window.location.origin ||
			!/^\/static\/(css|js)\//.test(url.pathname)
		) return null;
		return url;
	} catch {
		return null;
	}
};
